import React, { useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../../context/AuthContext";
import logoImg from "../../assets/logo.png";

export default function ContactUs() {
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: "",
    email: user?.email || "",
    subject: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await addDoc(collection(db, "messages"), {
        ...form,
        createdAt: serverTimestamp(),
        status: "Unread",
        fromUser: user?.uid || null,
      });
      setSuccess(true);
      setForm({ name: "", email: user?.email || "", subject: "", message: "" });
    } catch (err) {
      alert("Failed to send message. Please try again later.");
      console.error("Error sending message:", err);
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      style={{
        paddingTop: "20px",
		paddingBottom: "50px",
        minHeight: "100vh",
        backgroundColor: "rgba(55,65,81,0.8)",
        color: "#f3f4f6",
        padding: "1.5rem",
      }}
    >
      <h1
        style={{
          textAlign: "center",
          color: "gray",
          backgroundColor: "white",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          width: "fit-content",
          margin: "10px auto 0 auto",
          fontSize: "16px",
          fontWeight: "500",
          padding: "14px 24px",
          borderRadius: "20px",
        }}
      >
        Contact Us
      </h1>

      <div
        style={{
          maxWidth: "900px",
          margin: "40px auto",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          color: "#1f2937",
          boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Company Info Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "24px",
            borderBottom: "1px solid #e5e7eb",
            paddingBottom: "16px",
          }}
        >
          <div
			  style={{
				width: 52,
				height: 52,
				borderRadius: "50%",
				border: "2px solid #", // 👈 wider border
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: "#fff",
				boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
				marginRight: 12,
			  }}
			>
			  <img
				src={logoImg}
				alt="Convalesce Logo"
				style={{
				  width: 40,
				  height: 40,
				  borderRadius: "50%",
				}}
			  />
			</div>
			
			
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "700" }}>
              Convalesce Care & Recruitment LTD-UK
            </h2>
            <p style={{ fontSize: "13px", color: "#6b7280" }}>
              Your comfort, your choice, your care
            </p>
            <p style={{ fontSize: "13px", color: "#6b7280", marginTop: "6px" }}>
              📍 73 Johnson Rd, Croydon, CR0 2JS 
              <br />📞 +44 75 99 121 308  
              <br />✉️ admin@convalesceuk.com
            </p>
          </div>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label
              htmlFor="name"
              style={{
                display: "block",
                fontSize: "14px",
                color: "#6b7280",
                marginBottom: "6px",
              }}
            >
              Your Name
            </label>
            <input
              required
              id="name"
              name="name"
              type="text"
              placeholder="Enter your name"
              value={form.name}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            />
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                fontSize: "14px",
                color: "#6b7280",
                marginBottom: "6px",
              }}
            >
              Email Address
            </label>
            <input
              required
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              value={form.email}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            />
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label
              htmlFor="subject"
              style={{
                display: "block",
                fontSize: "14px",
                color: "#6b7280",
                marginBottom: "6px",
              }}
            >
              Subject
            </label>
            <input
              required
              id="subject"
              name="subject"
              type="text"
              placeholder="e.g. Shift issue, payment query..."
              value={form.subject}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            />
          </div>

          <div style={{ marginBottom: "16px" }}>
            <label
              htmlFor="message"
              style={{
                display: "block",
                fontSize: "14px",
                color: "#6b7280",
                marginBottom: "6px",
              }}
            >
              Message
            </label>
            <textarea
              required
              id="message"
              name="message"
              placeholder="Type your message..."
              rows="5"
              value={form.message}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                backgroundColor: "#f9fafb",
              }}
            />
          </div>

          <button
            type="submit"
            disabled={sending}
            style={{
              width: "100%",
              backgroundColor: sending ? "#9ca3af" : "#1e3a8a",
              color: "white",
              padding: "12px",
              borderRadius: "8px",
              cursor: sending ? "not-allowed" : "pointer",
              fontWeight: "600",
              transition: "background 0.2s ease",
            }}
          >
            {sending ? "Sending..." : "Send Message"}
          </button>

          {success && (
            <p
              style={{
                marginTop: "12px",
                textAlign: "center",
                color: "#16a34a",
                fontWeight: "500",
              }}
            >
              ✅ Your message has been sent successfully.
            </p>
          )}
        </form>
      </div>

      {/* Footer / Quick Links */}
      <div
        style={{
          textAlign: "center",
          color: "#9ca3af",
          marginTop: "30px",
          fontSize: "13px",
        }}
      >
        
      </div>
    </div>
  );
}
